module.exports = __webpack_public_path__ + "img/imgconsurebt.5b7a02f0.png";